export default "__VITE_ASSET__BOKYKsLZ__"